import {
    GET_GENDERCATEGORY_REQUEST, GET_GENDERCATEGORY_ERROR, GET_GENDERCATEGORY_SUCCESS,
    ADD_GENDERCATEGORY_SUCCESS, ADD_GENDERCATEGORY_ERROR, ADD_GENDERCATEGORY_REQUEST,
    UPDATE_GENDERCATEGORY_ERROR, UPDATE_GENDERCATEGORY_SUCCESS, UPDATE_GENDERCATEGORY_REQUEST,
    DELETE_GENDERCATEGORY_ERROR, DELETE_GENDERCATEGORY_SUCCESS, DELETE_GENDERCATEGORY_REQUEST,


} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_GENDERCATEGORY_REQUEST:
            return {
                loading: true,
            };
        case GET_GENDERCATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_GENDERCATEGORY_ERROR:
            return {
                ...state,
                loading: false
            };
        case ADD_GENDERCATEGORY_REQUEST:
            return {
                loading: true,
            };
        case ADD_GENDERCATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case ADD_GENDERCATEGORY_ERROR:
            return {
                ...state,
                loading: false
            };
        case DELETE_GENDERCATEGORY_REQUEST:
            return {
                loading: true,
            };
        case DELETE_GENDERCATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case DELETE_GENDERCATEGORY_ERROR:
            return {
                ...state,
                loading: false
            };
        case UPDATE_GENDERCATEGORY_REQUEST:
            return {
                loading: true,
            };
        case UPDATE_GENDERCATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case UPDATE_GENDERCATEGORY_ERROR:
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
}